import { SxProps } from '@mui/material'

export const tableActionIconStyles: SxProps = {
  cursor: 'pointer',
}
